/** DOM id of the lifestyle competition countdown strip. */
export const LIFESTYLE_COUNTDOWN_ID = "lifestyle-countdown";

/** Page-scoped offset so the filter bar stacks below header + countdown. */
export const LIFESTYLE_COUNTDOWN_HEIGHT_VAR = "--lifestyle-countdown-height";

export function syncLifestyleCountdownHeight(): void {
  const countdown = document.getElementById(LIFESTYLE_COUNTDOWN_ID);
  const height = countdown?.getBoundingClientRect().height ?? 0;
  document.documentElement.style.setProperty(LIFESTYLE_COUNTDOWN_HEIGHT_VAR, `${height}px`);
}

export function clearLifestyleCountdownHeight(): void {
  document.documentElement.style.removeProperty(LIFESTYLE_COUNTDOWN_HEIGHT_VAR);
}

export function getLifestyleCountdownHeight(): number {
  const parsed = parseFloat(
    getComputedStyle(document.documentElement).getPropertyValue(LIFESTYLE_COUNTDOWN_HEIGHT_VAR)
  );
  return Number.isFinite(parsed) ? parsed : 0;
}

/** Sticky `top` for the filter bar on /prizes/lifestyle only. */
export function getLifestyleFilterBarTop(): string {
  return `calc(var(--header-height) + var(${LIFESTYLE_COUNTDOWN_HEIGHT_VAR}, 0px))`;
}
